import axios from 'axios'
import { message } from 'ant-design-vue'
import { getToken, clearAuth } from '../utils/auth'
import router from '../router'

const request = axios.create({
  baseURL: '/',
  timeout: 600000
})

request.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

request.interceptors.response.use(
  response => {
    const res = response.data
    if (res && typeof res.code !== 'undefined' && res.code !== 200) {
      const isAuthApi = response.config && response.config.url && response.config.url.indexOf('/api/auth/login') >= 0
      if (!isAuthApi && (response.status === 401 || res.msg === '未登录或登录已过期')) {
        clearAuth()
        if (router.currentRoute.name !== 'Login') {
          router.replace({ name: 'Login', query: { redirect: router.currentRoute.fullPath } })
        }
      }
      message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    const url = error.config && error.config.url
    const isAuthApi = url && url.indexOf('/api/auth/login') >= 0
    if (!isAuthApi && error.response && error.response.status === 401) {
      clearAuth()
      if (router.currentRoute.name !== 'Login') {
        router.replace({ name: 'Login', query: { redirect: router.currentRoute.fullPath } })
      }
      message.error('未登录或登录已过期')
    } else {
      const msg =
        (error.response && error.response.data && error.response.data.msg) ||
        error.message ||
        '网络异常'
      message.error(msg)
    }
    return Promise.reject(error)
  }
)

export default request
